// Dashboard KPI presentation config (api-reference/admin-kpis.md). Pure data.
// El backend es dueño de los números y del `qualifier` (good|regular|bad) de cada
// tasa; el UI NUNCA recalcula umbrales — solo mapea a color y etiqueta.

// view=summary → production{}. `key` debe coincidir con el payload.
export const PRODUCTION_CARDS = [
    { key: 'opu_sessions', label: 'Sesiones OPU',          icon: 'briefcase', accent: 'accent' },
    { key: 'aspirations',  label: 'Aspiraciones',          icon: 'droplet',   accent: 'accent' },
    { key: 'clivages',     label: 'Clivages',              icon: 'sperm',     accent: 'primary' },
    { key: 'embryos',      label: 'Embriones',             icon: 'cell',      accent: 'primary' },
    { key: 'transfers',    label: 'Transferencias',        icon: 'lineage',   accent: 'accent' },
    { key: 'pregnancies',  label: 'Preñadas',              icon: 'animal',    accent: 'primary' },
    { key: 'births',       label: 'Partos',                icon: 'hospital',  accent: 'primary' },
    { key: 'losses',       label: 'Pérdidas embrionarias', icon: 'close',     accent: 'danger' },
];

// view=funnel → funnel.stages[] (ya viene ordenado). Etiqueta + color por etapa.
export const FUNNEL_LABELS = {
    ovocitos:     'Ovocitos',
    viables:      'Viables',
    embriones:    'Embriones',
    transferidos: 'Transferidos',
    confirmadas:  'Confirmadas', // funnel de receptora (transferidos → confirmadas → partos)
    preneces:     'Preñadas',
    partos:       'Partos',
};

// Rampa secuencial MONÓTONA sky → teal → verde (etapa temprana → tardía): cada paso
// oscurece y corre el matiz de azul a verde, sin volver atrás. Interpola por los
// anclajes de marca #3bb5ed (sky) → #04c2a0 (teal) → #047857 (verde profundo).
export const FUNNEL_COLORS = {
    ovocitos:     '#3bb5ed',
    viables:      '#25bace',
    embriones:    '#0fbfaf',
    transferidos: '#04b391',
    confirmadas:  '#049674',
    preneces:     '#049674',
    partos:       '#047857',
};

// view=rates → rates{}. `late` = tasa tardía (trae cohort_n). `inverted` = menor
// es mejor (pérdidas). El color lo dirige el `qualifier` del backend, no esto.
export const RATE_ROWS = [
    { key: 'viability',      label: 'Viabilidad' },
    { key: 'fertilization',  label: 'Fertilización' },
    { key: 'transfer',       label: 'Transferencia' },
    { key: 'pregnancy',      label: '% Concepción',          late: true },
    { key: 'survival',       label: 'Supervivencia',         late: true },
    { key: 'embryonic_loss', label: 'Pérdidas embrionarias', late: true, inverted: true },
];
